import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { addSignInUsingPost } from "@/request/api/userController";
import message from "@arco-design/web-vue/es/message";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckInButton',
  setup(__props) {

const checkIn = async () => {
  const res = await addSignInUsingPost();
  if (res.data.code === 0) {
    if (res.data.data == true) {
      message.success("签到成功");
      //刷新页面
      router.go(0);
    } else {
      message.success("今天已经签到过了哦");
    }
  } else {
    message.error("签到失败" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_link = _resolveComponent("a-link")!

  return (_openBlock(), _createBlock(_component_a_link, { onClick: checkIn }, {
    default: _withCtx(() => [
      _createTextVNode(" 打卡学习")
    ]),
    _: 1
  }))
}
}

})